import { useCallback } from 'react';

import { Offer_Engagement_Type, OfferFilter, Publication_Status_Type } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';

type UseMakeOffersFilterReturn = (search: string) => OfferFilter;

export const useMakeOffersFilter = (): UseMakeOffersFilterReturn => {
  const chainId = useChainId();

  return useCallback(
    (search: string): OfferFilter => ({
      search: search || null,
      chainIdEquals: chainId,
      engagementTypeIncludes: [
        Offer_Engagement_Type.Vouchered,
        Offer_Engagement_Type.FuelRollback,
        Offer_Engagement_Type.SweepstakesEntry,
        Offer_Engagement_Type.GameVoucher,
      ],
      deleted: false,
      publicationStatusEquals: Publication_Status_Type.Published,
    }),
    [chainId],
  );
};
